import CordovaUtils from './Cordova';
import Culture from './Culture';
import UserManager from './UserManager';
var ApiHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     */
    function ApiHelpers() {
        this.Initialize();
    }
    /**
     * Class initializer
     */
    ApiHelpers.prototype.Initialize = function () {
        this.ClientApi = process.env.REACT_APP_API;
        this.BaseApiPath = process.env.REACT_APP_BASEPI;
    };
    /**
     * Get application configuration
     * @param clientId Application client ID
     * @returns {Promise<any>} Json with the app configuration. If the result is different from 200, block, it is not authorized
     */
    ApiHelpers.prototype.GetAppConfig = function (clientId) {
        var _this = this;
        var that = this;
        return new Promise(function (resolve, reject) {
            UserManager.GetUser().then(function (user) {
                if (user !== null) {
                    that.Fetch(_this.BaseApiPath + "/api/config/" + clientId)
                        .then(function (response) {
                        if (response.status === 200) {
                            response.json().then(function (data) {
                                resolve(data);
                            }).catch(function (err) {
                                console.error('[API-2] - Error getting APP configuration');
                                console.error(err);
                                resolve(0);
                            });
                        }
                        else {
                            console.error('[API-3] - Base API return invalid status code');
                            resolve(0);
                        }
                    }).catch(function (err) {
                        console.error('[API-1] - Error checking base api permissions');
                        console.error(err);
                        resolve(0);
                    });
                }
                else {
                    resolve(-1);
                }
            });
        });
    };
    /**
     * Fetch data from API (NO authorization required)
     * @param {string} url Url to call
     * @returns {Promise<Response>} Promise with the http response
     */
    ApiHelpers.prototype.FetchUnauthorized = function (url) {
        var _this = this;
        url = this.ProcessUrl(url);
        return new Promise(function (resolve) {
            resolve(fetch(_this.AddCulture(url), {
                headers: {
                    'Cache-Control': 'no-cache, no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                },
            }));
        });
    };
    /**
     * Fetch data from API (authorization required)
     * @param {string} url Url to call
     * @returns {Promise<Response>} Promise with the http response
     */
    ApiHelpers.prototype.Fetch = function (url) {
        var _this = this;
        url = this.ProcessUrl(url);
        return new Promise(function (resolve, reject) {
            UserManager.GetUser().then(function (user) {
                resolve(fetch(_this.AddCulture(url), {
                    mode: "cors",
                    headers: {
                        'Authorization': 'Bearer ' + user.access_token,
                        'Cache-Control': 'no-cache, no-store',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    },
                }));
            }).catch(function (err) {
                console.error(err);
                reject(null);
            });
        });
    };
    /**
     * POST data to API
     * @param {string} url Url to call
     * @param {string} body json body
     * @param {string} contentType Content type
     * @param {string} dataType Data type
     * @returns {Promise<Response>} Promise with the http response
     */
    ApiHelpers.prototype.Post = function (url, body, contentType, dataType) {
        var _this = this;
        if (body === void 0) { body = null; }
        if (contentType === void 0) { contentType = 'application/json'; }
        if (dataType === void 0) { dataType = 'json'; }
        url = this.ProcessUrl(url);
        return new Promise(function (resolve, reject) {
            UserManager.GetUser().then(function (user) {
                resolve(fetch(_this.AddCulture(url), {
                    mode: "cors",
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + user.access_token,
                        'Cache-Control': 'no-cache, no-store',
                        'Pragma': 'no-cache',
                        'Expires': '0',
                        'Content-Type': contentType
                    },
                    body: body !== null ? body.toString() : null
                }));
            }).catch(function (err) {
                console.error(err);
                reject(null);
            });
        });
    };
    /**
     * POST data to API with an unauthorized request
     * @param {string} url Url to call
     * @param {string} body json body
     * @param {string} contentType Content type
     * @param {string} dataType Data type
     * @returns {Promise<Response>} Promise with the http response
     */
    ApiHelpers.prototype.PostUnauthorized = function (url, body, contentType, dataType) {
        var _this = this;
        if (body === void 0) { body = null; }
        if (contentType === void 0) { contentType = 'application/json'; }
        if (dataType === void 0) { dataType = 'json'; }
        url = this.ProcessUrl(url);
        return new Promise(function (resolve, reject) {
            resolve(fetch(_this.AddCulture(url), {
                mode: "cors",
                method: 'POST',
                headers: {
                    'Cache-Control': 'no-cache, no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Content-Type': contentType
                },
                body: body !== null ? body.toString() : null
            }));
        });
    };
    /**
     * Fetch with custom HTTP verb
     * @param {string} url Url to call
     * @param {string} verb HTTP verb to send
     * @param {any} body Body to send (in case it applies to the verb in question)
     * @param {string} contentType Call content type
     * @param {boolean} authorize Is authorization required
     * @returns {Promise<Response>} Promise with the http response
     */
    ApiHelpers.prototype.CustomVerb = function (url, verb, body, contentType, authorize) {
        var _this = this;
        if (verb === void 0) { verb = 'GET'; }
        if (body === void 0) { body = null; }
        if (contentType === void 0) { contentType = 'application/json'; }
        if (authorize === void 0) { authorize = true; }
        return new Promise(function (resolve, reject) {
            _this.GetCustomVerbHeaders(authorize, contentType).then(function (headers) {
                resolve(fetch(_this.AddCulture(_this.ProcessUrl(url)), {
                    mode: "cors",
                    method: verb.toUpperCase(),
                    headers: headers,
                    body: body !== null ? body.toString() : null
                }));
            }).catch(function (err) {
                console.error(err);
                reject(null);
            });
        });
    };
    /**
     * Get headers to send on the custom verb call
     * @param {boolean} authorize Is authorization required
     * @param {string} contentType Call content type
     * @returns {Promise<any>} returns a promise with the necessary headers
     */
    ApiHelpers.prototype.GetCustomVerbHeaders = function (authorize, contentType) {
        return new Promise(function (resolve) {
            if (!authorize) {
                resolve({
                    'Cache-Control': 'no-cache, no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Content-Type': contentType
                });
            }
            else {
                UserManager.GetUser().then(function (user) {
                    resolve({
                        'Authorization': 'Bearer ' + user.access_token,
                        'Cache-Control': 'no-cache, no-store',
                        'Pragma': 'no-cache',
                        'Expires': '0',
                        'Content-Type': contentType
                    });
                });
            }
        });
    };
    /**
     * Add culture query string
     * @param {string} url Url to append the culture to
     * @returns {string} new Url with the culture attached
     */
    ApiHelpers.prototype.AddCulture = function (url) {
        var culture = Culture.Get();
        return url + "?culture=" + culture + "-" + culture.toUpperCase();
    };
    /**
     * Check if URL has a valid format when running native
     * @param {string} url Url to check
     * @returns {string} New formated url
     */
    ApiHelpers.prototype.ProcessUrl = function (url) {
        var result = url;
        if (CordovaUtils.IsCordova) {
            if (url.indexOf('http:') === -1 && url.indexOf('https:') === -1) {
                result = result.replace("./", "/");
                if (result.substring(0, 1) !== '/') {
                    result = '/' + result;
                }
                result = this.ClientApi + result;
            }
        }
        return result;
    };
    return ApiHelpers;
}());
;
var Api = new ApiHelpers();
export default Api;
//# sourceMappingURL=Api.js.map